import { render, staticRenderFns } from "./ambassador.vue?vue&type=template&id=7d07e48c&scoped=true"
import script from "./ambassador.vue?vue&type=script&lang=js"
export * from "./ambassador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d07e48c",
  null
  
)

export default component.exports